module.exports = __webpack_public_path__ + "img/2020-06-24.93178087.jpg";